// Generated by scripts/scope-tours/order.ts. Do not edit by hand.
// The order the library teaches its modules in, inferred from the docs:
// sections as the library has them, topics within a section ordered by which
// concept the docs lean on, and modules within a topic by the docs' own
// heading order. A scope missing here sorts last.
export const CURRICULUM: string[] = [
    'view:MetricsTree',
    'view:Tags',
    'view:SpotlightTableConfig',
    'view:SavedChart',
    'manage:ExportCsv',
    'view:Dashboard',
    'view:DashboardComments',
    'view:Space',
    'view:PinnedItems',
    'manage:Tags',
    'view:ContentVerification',
    'manage:SavedChart',
    'manage:Dashboard',
    'create:DashboardComments',
    'manage:DashboardComments',
    'manage:ContentVerification',
    'manage:VerifiedContent',
    'create:Space',
    'manage:Space',
    'manage:ProjectHomepage',
    'manage:PinnedItems',
    'manage:ChangeCsvResults',
    'view:CompiledSql',
    'view:UnderlyingData',
    'manage:Explore',
    'manage:CustomSql',
    'manage:SqlRunner',
    'manage:CustomSqlTableCalculations',
    'manage:CustomFields',
    'create:VirtualView',
    'delete:VirtualView',
    'manage:VirtualView',
    'view:AiAgent',
    'create:AiAgentThread',
    'create:DataApp',
    'view:DataApp',
    'manage:DataApp',
    'manage:AiAgent',
    'create:AiDeepResearch',
    'manage:MetricsTree',
    'manage:SpotlightTableConfig',
];
